import { css } from '@emotion/css';
import { VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { MultiLineText, SingleSelect, Text } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap, noteStyle, Wrap } from 'Shared/forms/Wrap';
import type {EmbedLayout} from 'Shared/model/Components';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { Match, Show, Switch } from 'solid-js';
import { useLayout } from '../LayoutProvider';


export function Embed(P:EmbedLayout)
{
	const detailsStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '0.8em',
	});

	const lo = useLayout();

	return (
		<div class={detailsStyle}>
			<Show when={lo.layout()}>
				<div class={noteStyle()}>
					WARNING: only paste in code from providers you trust. Malicious code can trick visitors into
					providing personal information or display undesirable content on your pages.
					The 'Iframe' option is more secure than the 'Code' option.
				</div>

				<LabelOnLeftWrap label='Embed type'>
					<SingleSelect field='type' options={{iframe:'Iframe',code:'Code'}} required={true} />
				</LabelOnLeftWrap>

				<Switch>
					<Match when={P.type == 'iframe'}>
						<IFrame {...P} />
					</Match>
					<Match when={true}>
						<Js {...P} />
					</Match>
				</Switch>
			</Show>
		</div>
	);
}

function IFrame(P)
{
	const sw = useStore();

	/*
		TIP: leaving the iframe background unset causes it to use the sites background colour.

		Iframe heights are annoying. We could provide https://github.com/davidjbradshaw/iframe-resizer as a built-in 
		if there was a demand for it. This would be more secure than embedding the iframe provider's resizing code. 
		Note the alternative resizing libraries are much less popular.

		NOTE use Container to size it properly...
	*/

	return (<>
		<StoreProvider {...sw} location={[...sw.location,'height']}>
			<VerticalConstraint {...P.height} label='Height' options={['parent','ratio','height']} />
		</StoreProvider>

		<Wrap label='Embed iframe URL'>
			<Text field='url' required={true} />
		</Wrap>
	</>);
}

function Js(P)
{
	return (
		<div>
			<Wrap label='HTML embed code'>
				<MultiLineText field='code' numRows={8} />
			</Wrap>
		</div>
	);
}

